import { motion } from "framer-motion";
import QuotasSection from "./QuotasSection";
import { useEffect, useState } from "react";
import { getActiveQuotas, getPaymentsByRut, getQuotas } from "../../../services/quotasService";
import { PageLoader } from "../../loader";
import PaymentHistory from "./AuxQuotas/PaymentHistory";

const MyQuotasPartner = ({selectedSocio}) => {
    const [loading, setLoading] = useState(false);
    const [quotas, setQuotas] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [payments, setPayments] = useState([]);
    const loadQuotas = async (year) => {
        try{
          setLoading(true);
          const currentYear = year || new Date().getFullYear();
          const response = await getActiveQuotas(selectedSocio.rut, currentYear);
          setQuotas(response);
        } catch (error) {
          console.error("Error loading quotas:", error);
        } finally {
          setLoading(false);
        }
      }
    
      useEffect(() => {
        if (selectedSocio) {
          loadQuotas();
        }
      }
      , [selectedSocio, setLoading]);

    const handleBackToQuotas = () => {
        setShowHistory(false);
    }

    const loadPayments = async () => {
        try {
          setLoading(true);
          const response = await getPaymentsByRut(selectedSocio.rut);
          if (response.error) {
            console.error("Error fetching payments:", response.message);
            return;
          }
          setPayments(response);
        } catch (error) {
          console.error("Error loading payments:", error);
        } finally {
          setLoading(false);
        }
      }
      useEffect(() => {
        if (showHistory) {
          loadPayments();
        }
      }, [showHistory, selectedSocio]);
    const normalizedQuotas = Array.isArray(quotas) ? quotas : [];  
    return (
        <>
            {loading ? (
                <PageLoader message="Cargando cuotas del socio..." />
            ) : (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.1 }}
                >
                  {showHistory ? (
                    <PaymentHistory 
                      isOpen={showHistory} 
                      onClose={() => setShowHistory(false)} 
                      payments={payments} 
                      socio={selectedSocio} 
                      onBack={handleBackToQuotas}
                    />
                  ) : (
                    <QuotasSection onViewPaymentHistory={() => setShowHistory(true)} selectedSocio={selectedSocio} quotas={normalizedQuotas} />
                  )}
                </motion.div>
            )}
        </>
    );
}
export default MyQuotasPartner;